// import React, { useMemo } from "react";
// import { ArrowUpRight, ArrowDownRight, Info } from "lucide-react";

// const FinanceSummary = ({ financeData, dateRangeLabel }) => {
//   const summaryRows = financeData?.finance_summary || [];

//   const formatCurrency = (val) =>
//     `$${Number(val || 0).toLocaleString(undefined, {
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2,
//     })}`;

//   return (
//     <div
//       className="card shadow-sm mb-4"
//       style={{ borderRadius: "12px", border: "1px solid #E5E7EB" }}
//     >
//       <div className="card-body">

//      <div className="pt-3">

//               {/* --------- TITLE + DESCRIPTION --------- */}
//         <h5 className="fs-19 fw-medium mb-1">
//           Finance Summary ({dateRangeLabel})
//         </h5>
//         <p className="fs-14" style={{ fontSize: "0.85rem" }}>
//           (Default range — adjustable by date filter above)
//         </p>
//      </div>
//      <hr/>

//         {/* --------- TABLE --------- */}
//         <div className="table-responsive mt-3">
//           <table className="table align-middle mb-0">
//             <thead style={{backgroundColor:"white"}}>
//               <tr className="border-b border-gray-200">
//                 <th className="text-left  py-3 fw-medium fs-14  text-gray-700">Order Type</th>
//                 <th className="text-left py-3  fw-medium fs-14 text-gray-700">Revenue</th>
//                 <th className="text-left py-3  fw-medium fs-14 text-gray-700">Discounts</th>
//                 <th className="text-left py-3  fw-medium fs-14 text-gray-700">Special Fees</th>
//                 <th className="text-left py-3  fw-medium fs-14 text-gray-700">Net Revenue</th>
//               </tr>
//             </thead>

//             <tbody>
//               {summaryRows.map((row, idx) => {
//                 const up = row.change_pct >= 0;
//                 const TrendIcon = up ? ArrowUpRight : ArrowDownRight;
//                 const trendColor = up ? "#10b981" : "#ef4444";

//                 return (
//                   <tr key={idx}>
//                     <td className=" fw-medium fs-12">{row.order_type}</td>

//                     {/* Revenue */}
//                     <td>
//                       <span
//                         className="px-2 py-1 br-8 fw-medium"
//                         style={{
//                           background: "rgba(59,130,246,0.12)",
//                           color: "#1447e6",
//                           fontSize: "0.85rem",
//                           border : "1px solid rgba(59,130,246,0.30)",
//                         }}
//                       >
//                         {formatCurrency(row.revenue)}
//                       </span>
//                     </td>

//                     {/* Discounts */}
//                     <td>
//                       <span
//                         className="px-2 py-1 br-8 fw-medium"
//                         style={{
//                           background: "#ffedd4",
//                           color: "#ca3500",
//                           fontSize: "0.85rem",
//                           border : "1px solid #ffd7a8",
//                         }}
//                       >
//                         {formatCurrency(row.discounts)}
//                       </span>
//                     </td>

//                     {/* Special Fees */}
//                     <td>
//                       <span
//                         className="px-2 py-1 br-8 fw-medium"
//                         style={{
//                           background: "#f3e8ff",
//                           color: "#8200db",
//                           fontSize: "0.85rem",
//                           border : "1px solid #e9d4ff",
//                         }}
//                       >
//                         {formatCurrency(row.special_fees)}
//                       </span>
//                     </td>

//                     {/* Net Revenue + Arrow */}
//                     <td>
//                       <div
//                         className="fw-bold d-flex align-items-center gap-1"
//                         style={{ color: trendColor, fontSize: "0.95rem" }}
//                       >
//                           <span
//                         className="px-2 py-1 br-8 fw-medium"
//                         style={{
//                           background: "#dcfce7",
//                           color: "#008236",
//                           fontSize: "0.85rem",
//                           border : "1px solid #b9f8cf",
//                         }}
//                       >
//                         {formatCurrency(row.net_revenue)}
//                       </span>
//                         {/* {formatCurrency(row.net_revenue)} */}
//                         <TrendIcon size={16} />
//                         <span
//                           className="ms-1"
//                           style={{ fontSize: "0.85rem", color: trendColor }}
//                         >
//                           {row.change_pct}%
//                         </span>
//                       </div>
//                     </td>
//                   </tr>
//                 );
//               })}
//             </tbody>
//           </table>
//         </div>

//         {/* --------- FOOTER INFO --------- */}
//         <div
//           className="d-flex align-items-start gap-2 mt-4 p-3 br-8"
//           style={{
//             backgroundColor: "rgba(59,130,246,0.08)",
//             color: "#2563eb",
//             fontSize: "0.9rem",
//           }}
//         >
//           <Info size={18} className="mt-1" />
//           <span>
//             Finance data reflects totals from the selected date range.
//             Hover over each cell to view order-level details.
//           </span>
//         </div>
//       </div>
//       <style>{`
//         .border-b {
//          border-bottom-width: 1px;
//         }
//         .border-gray-200 {
//           border-color:#ebe6e7 ;
//         }
//           .text-gray-700 {
//           color: #364153 ;
//         }
//           .text-align {
//           text-align: left;
//         }
//           .fw-semibold {
//           font-weight: 600;
//         }
         
//       `}</style>
//     </div>
//   );
// };

// export default FinanceSummary;



import React from "react";
import { ArrowUpRight, ArrowDownRight, Info } from "lucide-react";
import { DesktopTableParts, MobileCardsOnly } from "components/TableandMobilecomponent";
import { useReactTable, getCoreRowModel, createColumnHelper } from "@tanstack/react-table";

interface FinanceSummaryRow {
  order_type: string;
  revenue: number;
  discounts: number;
  special_fees: number;
  net_revenue: number;
  change_pct: number;
  tax_amount: number;
  sub_total: number;
}

interface FinanceSummaryProps {
  financeData: {
    finance_summary?: FinanceSummaryRow[];
    [key: string]: any;   // <-- allow all other fields (fix parent error)
  };
  dateRangeLabel: string;
}


const FinanceSummary: React.FC<FinanceSummaryProps> = ({ financeData, dateRangeLabel }) => {
  const summaryRows = financeData?.finance_summary || [];
  const columnHelper = createColumnHelper<FinanceSummaryRow>();

  /* ---------- COLUMNS FOR DESKTOP + MOBILE ---------- */
  const columns = [
    columnHelper.accessor("order_type", {
      header: "Order Type",
      cell: (info) => <span className="fw-medium fs-12">{info.getValue()}</span>,
    }),
columnHelper.accessor("sub_total", {
  header: "Sub Total",
  cell: (info) => {
    const raw = info.getValue();
    const amount = Number(raw);

    const safeAmount = Number.isFinite(amount) ? amount : 0;

    return (
      <span
        className="px-2 py-1 br-8 fw-medium"
        style={{
          background: "#ffedd4",
          color: "#ca3500",
          fontSize: "0.85rem",
          border: "1px solid #ffd7a8",
        }}
      >
        ${safeAmount.toLocaleString()}
      </span>
    );
  },
}),

     columnHelper.accessor("special_fees", {
      header: "Special Fees",
      cell: (info) => (
        <span
          className="px-2 py-1 br-8 fw-medium"
          style={{
            background: "#f3e8ff",
            color: "#8200db",
            fontSize: "0.85rem",
            border: "1px solid #e9d4ff",
          }}
        >
          ${Number(info.getValue()).toLocaleString()}
        </span>
      ),
    }),
      columnHelper.accessor("tax_amount", {
      header: "Tax Amount",
      cell: (info) => (
        <span
          className="px-2 py-1 br-8 fw-medium"
          style={{
            background: "#f3e8ff",
            color: "#8200db",
            fontSize: "0.85rem",
            border: "1px solid #e9d4ff",
          }}
        >
          ${Number(info.getValue()).toLocaleString()}
        </span>
      ),
    }),

    columnHelper.accessor("revenue", {
      header: "Gross Revenue",
      cell: (info) => (
        <span
          className="px-2 py-1 br-8 fw-medium"
          style={{
            background: "rgba(59,130,246,0.12)",
            color: "#1447e6",
            fontSize: "0.85rem",
            border: "1px solid rgba(59,130,246,0.30)",
          }}
        >
          ${Number(info.getValue()).toLocaleString()}
        </span>
      ),
    }),

    // columnHelper.accessor("discounts", {
    //   header: "Discounts",
    //   cell: (info) => (
    //     <span
    //       className="px-2 py-1 br-8 fw-medium"
    //       style={{
    //         background: "#ffedd4",
    //         color: "#ca3500",
    //         fontSize: "0.85rem",
    //         border: "1px solid #ffd7a8",
    //       }}
    //     >
    //       ${Number(info.getValue()).toLocaleString()}
    //     </span>
    //   ),
    // }),

    columnHelper.accessor("net_revenue", {
      header: "Net Revenue",
      cell: (info) => {
        const row = info.row.original;
        const up = row.change_pct >= 0;
        const TrendIcon = up ? ArrowUpRight : ArrowDownRight;
        const trendColor = up ? "#10b981" : "#ef4444";

        return (
          <div className="fw-bold d-flex align-items-center gap-1" style={{ color: trendColor }}>
            <span
              className="px-2 py-1 br-8 fw-medium"
              style={{
                background: "#dcfce7",
                color: "#008236",
                fontSize: "0.85rem",
                border: "1px solid #b9f8cf",
              }}
            >
              ${Number(row.net_revenue).toLocaleString()}
            </span>
            <TrendIcon size={16} />
            <span className="ms-1" style={{ fontSize: "0.85rem", color: trendColor }}>
              {(row.change_pct || 0).toFixed(2)}%
            </span>
          </div>
        );
      },
    }),
  ];

  const table = useReactTable({
    data: summaryRows,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <div
      className="card shadow-sm mb-4"
      style={{ borderRadius: "12px", border: "1px solid #E5E7EB" }}
    >
      <div className="card-body">
        <div className="pt-3">
          <h5 className="fs-19 fw-medium mb-1">Finance Summary ({dateRangeLabel})</h5>
          <p className="fs-14" style={{ fontSize: "0.85rem" }}>
            (Default range — adjustable by date filter above)
          </p>
        </div>

        <hr />

        {/* ---------- DESKTOP TABLE (≥1022px) ---------- */}
        <div className="table-responsive mt-3 rdt-desktop">
          <table className="table align-middle mb-0">
            <DesktopTableParts table={table} />
          </table>
        </div>

        {/* ---------- MOBILE CARDS (≤1021px) ---------- */}
        <div className="rdt-mobile mt-3">
          <MobileCardsOnly
            table={table}
            idColId="order_type"
            titleColId="order_type"
            omitMobile={[]}
          />
        </div>

        {/* ---------- FOOTER INFO ---------- */}
        <div
          className="d-flex align-items-start gap-2 mt-4 p-3 br-8"
          style={{ backgroundColor: "#eff6ff", color: "#1c398e", border:"1px solid #bedbff" }}
        >
          <span className="fs-16">💡</span>
          <span className="fs-14">
            Finance data reflects totals from the selected date range. Hover over each cell to view
            order-level details.
          </span>
        </div>
      </div>
    </div>
  );
};

export default FinanceSummary;
